/* ============================================================
   Don Don Care — Heat Compare Slider interaction
   Updates --pos CSS var based on range input or pointer drag.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    const sliders = document.querySelectorAll('.ddc-heat');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      if (slider.dataset.ddcHeatInit === '1') return;
      slider.dataset.ddcHeatInit = '1';

      const range = slider.querySelector('.ddc-heat__range');
      if (!range) return;

      const setPos = (val) => {
        slider.style.setProperty('--pos', val + '%');
      };

      setPos(range.value);

      range.addEventListener('input', (e) => {
        setPos(e.target.value);
        slider.classList.add('was-touched');
      });

      range.addEventListener('pointerdown', () => {
        slider.classList.add('is-dragging');
      });

      const release = () => slider.classList.remove('is-dragging');
      range.addEventListener('pointerup', release);
      range.addEventListener('pointercancel', release);
      range.addEventListener('blur', release);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
